import { render, staticRenderFns } from "./tramite.vue?vue&type=template&id=76a736ec"
import script from "./tramite.vue?vue&type=script&lang=js"
export * from "./tramite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports